import React from "react";
import {loadingSpin} from "./routingContainer";
import {AuthInitialized, Protected} from "./routingWrappers";
import {ApplicationUserRole} from "../../api";

const Main = React.lazy(() => import("../mainPage/mainPage"));
const Login = React.lazy(() => import( "../components/loginPage"));
const Users = React.lazy(() => import("../applicationUser/applicationUserListContainer"));

const ReportingUsers = React.lazy(() => import("../reportingUser/reportingUserListContainer"));
const ReportingUserDetails = React.lazy(() => import("../reportingUser/reportingUserDetailsContainer"));

const Transactions = React.lazy(() => import("../transaction/transactionListContainer"));
const TransactionDetails = React.lazy(() => import("../transaction/transactionDetailsContainer"));

const ForgotPassword = React.lazy(() => import("../components/forgotPassword"));
const ForgotPasswordComplete = React.lazy(() => import("../components/forgotPasswordComplete"));
const Activate = React.lazy(() => import("../authentication/activate/activatePage"));

const DeviceManualUpdate = React.lazy(() => import("../deviceManualUpdate/deviceManualUpdateContainer"))
const LmCommunicationHistory = React.lazy(() => import("../lmCommunicationHistory/lmCommunicationHistoryListContainer"));
const LmCommunicationHistoryDetails = React.lazy(() => import("../lmCommunicationHistory/lmCommunicationHistoryDetailsContainer"));

export const LoginPage = () => <AuthInitialized loadingIndicator={loadingSpin}>
    <Login/>
</AuthInitialized>;

export const ForgotPasswordPage = () => <AuthInitialized loadingIndicator={loadingSpin}>
    <ForgotPassword/>
</AuthInitialized>;

export const ForgotPasswordCompletePage = () => <AuthInitialized loadingIndicator={loadingSpin}>
    <ForgotPasswordComplete/>
</AuthInitialized>

export const ActivatePage = () => <AuthInitialized loadingIndicator={loadingSpin}>
    <Activate/>
</AuthInitialized>;

export const MainPage = () => <Protected loadingIndicator={loadingSpin}>
    <Main/>
</Protected>

export const UsersPage = () => <Protected
    loadingIndicator={loadingSpin}
    allowedForRoles={[ApplicationUserRole.Admin]}>
    <Users/>
</Protected>

export const ReportingUsersPage = () => <Protected loadingIndicator={loadingSpin}>
    <ReportingUsers/>
</Protected>

export const ReportingUserDetailsPage = () => <Protected loadingIndicator={loadingSpin}>
    <ReportingUserDetails/>
</Protected>


export const TransactionsPage = () => <Protected loadingIndicator={loadingSpin}>
    <Transactions/>
</Protected>

export const TransactionDetailsPage = () => <Protected loadingIndicator={loadingSpin}>
    <TransactionDetails/>
</Protected>

export const DeviceManualUpdatePage = () => <Protected
    loadingIndicator={loadingSpin}
    allowedForRoles={[ApplicationUserRole.Admin]}
>
    <DeviceManualUpdate/>
</Protected>

export const LmCommunicationHistoryPage = () => <Protected
    loadingIndicator={loadingSpin}
    allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.LmItSupport]}
>
    <LmCommunicationHistory/>
</Protected>

export const LmCommunicationHistoryDetailsPage = () => <Protected
    loadingIndicator={loadingSpin}
    allowedForRoles={[ApplicationUserRole.Admin, ApplicationUserRole.LmItSupport]}
>
    <LmCommunicationHistoryDetails/>
</Protected>

